import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=15b83c75&scoped=true&"
import script from "./AppFoot.vue?vue&type=script&lang=ts&"
export * from "./AppFoot.vue?vue&type=script&lang=ts&"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=15b83c75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b83c75",
  null
  
)

component.options.__file = "AppFoot.vue"
export default component.exports